import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabase/supabase';

const OrderSmsPreferences = ({ userId }) => {
  const [phone, setPhone] = useState('');
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!userId) return;
    supabase.from('sms_preferences_1793049000000')
      .select('phone_e164,consented_at,opted_out_at')
      .eq('user_id', userId)
      .maybeSingle()
      .then(({ data, error }) => {
        if (error) {
          setMessage('SMS settings are unavailable until the SMS migration is applied.');
          return;
        }
        setPhone(data?.phone_e164 || '');
        setEnabled(Boolean(data?.consented_at && !data?.opted_out_at));
      });
  }, [userId]);

  const save = async (consent) => {
    setBusy(true);
    setMessage('');
    const { error } = await supabase.rpc('set_order_sms_consent_1793049000000', {
      p_phone: phone,
      p_consent: consent
    });
    if (error) setMessage(error.message);
    else {
      setEnabled(consent);
      setMessage(consent ? 'SMS alerts enabled.' : 'SMS alerts disabled.');
    }
    setBusy(false);
  };

  return (
    <div className="bg-white rounded-[2.5rem] shadow-xl p-8 md:p-10 border border-gray-100">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-xl font-black text-gray-900">Order SMS Alerts</h2>
        <span className="rounded-full bg-amber-50 px-3 py-1 text-xs font-black uppercase tracking-widest text-amber-700">
          Coming soon
        </span>
      </div>
      <p className="text-sm text-gray-500 mt-2">
        Order SMS alerts are coming soon. Optional texts when your order is being prepared, ready for pickup, or verified as picked up. Message and data rates may apply. Reply STOP anytime.
      </p>
      <label className="block text-xs font-black text-gray-400 uppercase tracking-widest mt-6 mb-2">
        Mobile number with country code
      </label>
      <input
        type="tel"
        value={phone}
        onChange={(event) => setPhone(event.target.value)}
        placeholder="+14155551234"
        className="w-full px-5 py-4 bg-gray-50 rounded-2xl outline-none focus:ring-2 focus:ring-emerald-500"
      />
      <div className="flex flex-wrap gap-3 mt-5">
        <button type="button" disabled={busy} onClick={() => save(true)}
          className="px-6 py-3 bg-emerald-600 text-white rounded-2xl font-bold disabled:opacity-50">
          {enabled ? 'Update SMS consent' : 'I agree to receive order texts'}
        </button>
        {enabled && (
          <button type="button" disabled={busy} onClick={() => save(false)}
            className="px-6 py-3 bg-gray-100 text-gray-800 rounded-2xl font-bold disabled:opacity-50">
            Turn off SMS
          </button>
        )}
      </div>
      {message && <p role="status" className="text-sm text-gray-600 mt-4">{message}</p>}
    </div>
  );
};

export default OrderSmsPreferences;
